import { type WrappedInsightTeamAndConnectionsAttributes } from "@clipboard-health/contract-backend-main";
import { Image, Text } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";

import handsIcon from "../../assets/hands-wrapped.png";

interface TeamAndConnectionsContentProps {
  attributes: WrappedInsightTeamAndConnectionsAttributes;
}

export function TeamAndConnectionsContent(props: TeamAndConnectionsContentProps) {
  const { attributes } = props;

  return (
    <Stack flex={1} position="relative" overflow="hidden">
      {/* Hands image - top right */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          right: 0,
          // marginTop: "-100px",
          pointerEvents: "none",
        }}
      >
        <Image src={handsIcon} alt="Hands" />
      </Box>

      {/* Text section */}
      <Stack
        position="absolute"
        sx={{
          top: "40%",
        }}
        paddingX={8}
        spacing={12}
      >
        <Text variant="body1" color="white">
          We know you couldn&apos;t do it without your team.{"\n"}This year you worked with
        </Text>

        <Stack spacing={5}>
          {attributes.peopleWorkedWith.slice(0, 5).map((person) => (
            <Text
              key={person}
              semibold
              variant="h3"
              color="white"
              sx={{
                fontSize: "1.75rem",
                maxWidth: "300px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {person}
            </Text>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
